export class Inboxe {
  id = null;
  from = null;
  to = null;
  empId = null;
  nextUserIdConfirmation = null;
  confirmedBy = null;
  confirmedUser = null;
  employeeUser = null;
  readAt = null;
  type='';
}
export class Deputy {
  startDate = null;
  endDate = null;
  substitute = null;
  id = null;
  employee = null;
  substituteId = null;
}
export class Employee {
  id = null;
  name = null;
  surname = null;
  fullName = null;
  birthday = null;
  hireDate = null;
}
export class InboxeViewModel {
  dialogs = { newSubstitutes: false, deputies: false, deleteInbox: false };
  inboxes: Inboxe[] = [];
  deputies: Deputy[] = [];
  employees: Employee[] = [];
  deputy: Deputy = null;
  employeeInbox: Employee = null;
  employeesInbox: Employee[] = [];
  toggleModalNewSubstitutes() {
    this.dialogs.newSubstitutes = !this.dialogs.newSubstitutes;
  }
}
